import { ToolInvocationStatus } from '../assistant';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_TOOL_INVOCATION_STATUS = 'TOOL_INVOCATION_STATUS_';

export const ToolInvocationStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_TOOL_INVOCATION_STATUS}${ToolInvocationStatus.PENDING}`]: 'En attente',
    [`${TRANSLATE_KEY_TOOL_INVOCATION_STATUS}${ToolInvocationStatus.SUCCESS}`]: 'Succès',
    [`${TRANSLATE_KEY_TOOL_INVOCATION_STATUS}${ToolInvocationStatus.ERROR}`]: 'Erreur',
    [`${TRANSLATE_KEY_TOOL_INVOCATION_STATUS}${ToolInvocationStatus.REFUSED}`]: 'Refusé',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  ToolInvocationStatus,
  ToolInvocationStatusTranslation,
  TRANSLATE_KEY_TOOL_INVOCATION_STATUS,
  true,
);
